import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Would you subscribe to this service?",
  "description": "",
  "published": "2012-04-05T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4121"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`write about the "what did you ship today" idea and ask if people would use it, what don't they like etc.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      